<script>
export default {
  name: 'SelectFromListModal',
  props: {
    id: { type: String, required: true },
    title: { type: String, required: true },
  },
  data() {
    return {
      list: [],
      resolvePromise: null,
      rejectPromise: null,
      selectAll: false,
    };
  },
  methods: {
    show(list) {
      return new Promise((resolve, reject) => {
        this.list = list.map((x) => ({ name: x, selected: true }));

        this.$bvModal.show(this.id);

        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    selectAllChanged() {
      this.list = this.list.map(({ name }) => {
        return { name, selected: this.selectAll };
      });
    },
  },
  computed: {
    selected() {
      if (this.list == null) return [];

      return this.list.filter((x) => x.selected).map((x) => x.name);
    },
  },
  watch: {
    list: {
      deep: true,
      handler() {
        if (this.list == null) return;

        this.selectAll = this.selected.length >= this.list.length;
      },
    },
  },
};
</script>

<template>
  <b-modal
    :id="id"
    @cancel="resolvePromise({ canceled: true })"
    @ok="resolvePromise({ canceled: false, selected })"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :hide-header="true"
  >
    <div class="flex-center-align">
      <h2>{{ title }}</h2>
      <b-form-checkbox
        class="flex-push"
        v-model="selectAll"
        @change="selectAllChanged"
        size="lg"
      >
        {{ selectAll ? $t('general.selectNone') : $t('general.selectAll') }}
      </b-form-checkbox>
    </div>

    <div class="selection-list">
      <div v-for="item in list" :key="item.name" class="selection-list-item">
        <b-form-checkbox class="flex-push" v-model="item.selected" size="lg">
          {{ item.name }}
        </b-form-checkbox>
      </div>
    </div>
  </b-modal>
</template>

<style scoped>
.selection-list {
  margin-left: 30px;
}

.selection-list-item {
  margin: 10px 0;
}
</style>
